export default __webpack_public_path__ + "static/media/Very happy.d781e0fd.svg";